<main class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1>Cadastrar licença</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <form [formGroup]="licencaForm">
                <div class="row">
                    <div class="form-group col-6">
                        <label id="label-input">
                            <span>Produto:</span>
                        </label>
                        <select type="number" formControlName="fk_produto" class="input form-control form-control-sm"
                            required>
                            <option [value]="produto.sr_id" *ngFor="let produto of produtos">
                                {{ produto.vc_nome }}
                            </option>
                        </select>
                        <ng-container *ngIf="licencaForm.controls.fk_produto.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.fk_produto.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                    <div class="form-group col-6">
                        <label id="label-input">
                            <span>Valor:</span>
                        </label>
                        <input formControlName="fl_valor" class="input form-control form-control-sm" type="number">
                        <ng-container *ngIf="licencaForm.controls.fl_valor.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.fl_valor.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                    <div class="form-group col-6">
                        <label id="label-input">
                            <span>Nome da licença:</span>
                        </label>
                        <input formControlName="vc_nome" class="input form-control form-control-sm" type="text">
                        <ng-container *ngIf="licencaForm.controls.vc_nome.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.vc_nome.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex flex-row justify-content-center">
                        <h2>Campos da licença:</h2>
                    </div>
                </div>
                <div formArrayName="camposAdicionais">
                    <div *ngFor="let acao of camposAdicionais.controls; let i = index">
                        <div class="row" [formGroupName]="i" class="d-flex flex-row justify-content-center">
                            <div class="form-group col-4">
                                <input formControlName="vc_campo" class="input form-control form-control-sm"
                                    type="text">
                            </div>
                            <div class="form-group col-5 d-flex flex-row align-items-center text-center">
                                <input formControlName="bl_pertence_token" type="checkbox"
                                    aria-label="Checkbox for following text input">
                                <label class="m-0 ml-1">Deve conter no token</label>
                            </div>
                            <div class="form-group col-1">
                                <button mat-button class="botao-add d-flex justify-content-center align-items-center"
                                    (click)="removerCampo(i)" *ngIf="i != 0">
                                    <img src="../assets/excluir.png" style="height: 1.5rem" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center">
                        <button mat-button class="botao-add d-flex justify-content-center" (click)="adicionarCampo()">
                            <img src="../assets/adiconar.svg" />
                        </button>
                    </div>
                </div>
                <div id="buttons">
                    <button class="btn-sucesso btn btn-lg btn-success" type="submit"
                        [ngClass]="{ 'btn-desabilitado': !licencaForm.valid }" [disabled]="!licencaForm.valid"
                        (click)="cadastrar()">
                        Cadastrar
                    </button>
                    <button class="btn-cancelar btn btn-lg btn-danger" type="button" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </div>
</main>